import { SnowplowService } from 'wanderu-service-analytics';

const sendEvent = (action, label, property) => SnowplowService.fireStructuredEvent({
    action,
    category: 'explore_page',
    label,
    property,
});

const clickSearch = ({ date, origin, price }) => sendEvent('click', 'update_search', { date, origin, price_range: price });

const clickCard = ({
    date,
    destination,
    isExpanding,
    origin,
    price,
}) => sendEvent('click', 'trip_suggestion', {
    destination,
    is_expanding: isExpanding,
    origin,
    price_range: price,
    suggested_date: date,
});

const selectResult = ({
    tripId,
    batchId,
    price,
    totalTrips,
    position,
}) => sendEvent('select_result', 'depart', {
    batch_id: batchId,
    position,
    price,
    results_count: totalTrips,
    trip_id: tripId,
});

const clickSeeAll = () => sendEvent('click', 'see_all_trips');

const events = {
    clickCard,
    clickSearch,
    clickSeeAll,
    selectResult,
};

export default events;
